// Copyright (c) 2020 Deere & Company

import React, {PropTypes} from 'react';
import Favorite from '@deere/cps-it.warranty-model-factory/lib/favorite';
import FavoriteslistItem from './favorite-list-item';

const FavoritesList = props => (<div className='favourites-list'>
    <ul>
        {
            props.favorites.map((item, index) =>
                <FavoriteslistItem
                    item={item.id}
                    key={index}
                    onFavoriteshandler={props.handleFavoritesClick}
                    to={item.route}
                />
            )
        }
    </ul>
</div>);

FavoritesList.displayName = 'FavoritesList';
FavoritesList.propTypes = {
    favorites: PropTypes.arrayOf(PropTypes.instanceOf(Favorite)).isRequired,
    handleFavoritesClick: PropTypes.func.isRequired

};
export default FavoritesList;



// WEBPACK FOOTER //
// ./src/shared/components/favorites/favorite-list.js